import * as yup from 'yup'

const schema = yup.object().shape({
  responsibleName: yup.string().when('selectExistentResponsible', {
    is: (value) => !value,
    then: yup.string().required(),
  }),
  responsibleEmail: yup.string().when('selectExistentResponsible', {
    is: (value) => !value,
    then: yup.string().email().required(),
  }),
  responsibleDpo: yup
    .object()
    .nullable()
    .when('selectExistentResponsible', {
      is: (value) => value,
      then: yup.object().required().typeError('Selecione um usuário'),
    }),
})

export default schema
